import React from 'react';
import { useSelector } from 'react-redux';

import MediaEmbed from '~/Share/components/NextGen/MediaEmbed';
import Video from '~/Share/components/Video';
import { EmbedItem, EmbedType, MessageTemplateShare } from '~/types/models';
import { ReduxState } from '~/types/redux/share';
import cx from 'classnames';

export type MessageTemplateEmbedsProps = {
  messageTemplate: MessageTemplateShare;
  embedContainerClassName?: string;
  embedClassName?: string;
};

export default function MessageTemplateEmbeds({
  messageTemplate,
  embedContainerClassName,
  embedClassName
}: MessageTemplateEmbedsProps) {
  const { videoEmbedPlayed } = useSelector((state: ReduxState) => ({
    videoEmbedPlayed: state.tracking.videoEmbedPlayed,
  }));

  return (
    <>
      {messageTemplate.embeds.map((embed: EmbedItem) => (
        <div className={cx('embed-container', embedContainerClassName)} key={embed.id}>
          {embed.type === EmbedType.Video ? (
            <Video
              className={embedClassName}
              videoUrl={`${embed.model?.video_url as string}#t=0.1`}
              controls
              onPlay={videoEmbedPlayed}
            />
          ) : (
            <MediaEmbed html={embed.data?.html} />
          )}
        </div>
      ))}
    </>
  );
}
